import React, { Component } from "react";
import { connect } from "react-redux";

import {
  setPopup,
  setMenuState,
  setCurrentCategory,
  setCategoryMenuState,
} from "../actions/siteActions";

class CategoriesMenu extends Component {
  setCategory = (category) => {
    this.props.setCurrentCategory(category);
    this.props.setCategoryMenuState(false);
  };

  createCategoryButtons = () => {
    const { site } = this.props;
    if (site.categories) {
      return Object.keys(site.categories).map((cat, i) => {
        return (
          <li key={i}>
            <button
              onClick={() => this.setCategory(site.categories[cat])}
              className="button"
            >
              {site.categories[cat].name}
            </button>
          </li>
        );
      });
    }
  };

  render() {
    const { site } = this.props;
    let firstPageImage =
      site.options && site.options.acf && site.options.acf.mobileMenuImg
        ? site.options.acf.mobileMenuImg.sizes.medium_large
        : process.env.PUBLIC_URL + "/img/riidetaust.jpg";
    return (
      <div
        className="categoriesMenu"
        style={{
          backgroundImage: "url(" + firstPageImage + ")",
        }}
      >
        <h1>TOOTEKATALOOG</h1>
        <div className="subMenu">
          <ul>{this.createCategoryButtons()}</ul>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  site: state.site,
});

export default connect(mapStateToProps, {
  setPopup,
  setMenuState,
  setCurrentCategory,
  setCategoryMenuState,
})(CategoriesMenu);
